import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'dvl-bracelet-picker',
  templateUrl: './bracelet-picker.component.html'
})
export class DvlBraceletPickerComponent {
  @Input() bracelets: any[];
  @Output("submit") submitEmitter: EventEmitter<string>;

  constructor() {
    this.submitEmitter = new EventEmitter<string>();
  }

  select(key: any): void {
    this.submitEmitter.emit(key);
  }
}



// WEBPACK FOOTER //
// /Proyectos-Ankaa/proyecto-meriendas-diverland/src/app/reception/components/bracelet-picker/bracelet-picker.component.ts